import { Button, Field, Input } from '@cloudflare/kumo';
import { useState } from 'react';
import { ICONS } from './icons';

/**
 * Campo de senha.
 *
 * O Cloudscape não tem o `PasswordInput` do LeafyGreen — esta é a primitiva
 * nova que o substitui: `Input type="password"` + um botão que revela a
 * senha. O `Input` do Cloudscape já oferece `type="password"`.
 */

export interface PasswordFieldProps {
  /** Rótulo visível do campo. */
  label?: string;
  value: string;
  /** Recebe o novo valor. */
  onChange: (value: string) => void;
  placeholder?: string;
  autoComplete?: string;
  disabled?: boolean;
  /** Mensagem de erro exibida abaixo do campo. */
  errorText?: string;
  'data-testid'?: string;
}

export function PasswordField({ label, value, onChange, placeholder, autoComplete, disabled, errorText, ...rest }: PasswordFieldProps) {
  const [visible, setVisible] = useState(false);

  return (
    <Field label={label} error={errorText ? { message: errorText, match: true } : undefined}>
      <div className="block">
        <div className="flex items-center gap-2"><div className="min-w-0 flex-1 [&>*]:w-full"><Input className="w-full" onChange={(e) => onChange(e.target.value)} aria-label={label} type={visible ? 'text' : 'password'} value={value} placeholder={placeholder} autoComplete={autoComplete} disabled={disabled} {...(rest)} /></div><Button variant="ghost" shape="square" icon={ICONS.Visibility} aria-label={visible ? 'Ocultar senha' : 'Mostrar senha'} onClick={() => setVisible((v) => !v)} /></div>
      </div>
    </Field>
  );
}
